export default "__VITE_ASSET__Blkenud9__"